import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { LeavePolicy, LeavePolicyCreate } from '../interfaces/leave.interface';

export const LeavePolicyService = {
    getPoliciesByInstitution: async (): Promise<LeavePolicy[]> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.LEAVE_POLICY.BY_INSTITUTION(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    createOrUpdate: async (data: LeavePolicyCreate): Promise<LeavePolicy> => {
        data.institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.LEAVE_POLICY.BASE, data, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    setActiveStatus: async (id: string, isActive: boolean): Promise<LeavePolicy> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_POLICY.SET_ACTIVE(id), { isActive }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    }
};
